import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p423254300950507520',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
